import { captureException } from '@sentry/nuxt';
import type {
  GetNewsArticlesQuery,
  GetNewsArticlesQueryVariables,
  StrapiArticle,
} from '~/apollo/types/types';
import useNewsTypes from './useNewsTypes';
import type SelectItem from '~/components/form/dropdown/types';
import { GetNewsArticles } from '~/apollo/types/types';

export default async () => {
  const { locale } = useI18n();

  const currentPage = ref<number>(0);
  const isLoadingArticles = ref<boolean>(false);
  const { currentNewsType, currentNewsTypeForGql, newsTypeOptions } =
    useNewsTypes();

  const limit = computed(() => {
    let currentLimit = 13;
    if (currentPage.value > 0) {
      currentLimit = 12;
    }

    return currentLimit;
  });

  const offset = computed(() => {
    let currentOffset = 0;
    if (currentPage.value > 0) {
      currentOffset = (currentPage.value - 1) * 12 + 13;
    }
    return currentOffset;
  });

  const fetchArticles = async () => {
    isLoadingArticles.value = true;

    const { data: articlesData, error: articlesError } = await useLegacyApollo<
      GetNewsArticlesQuery,
      GetNewsArticlesQueryVariables
    >(GetNewsArticles, {
      locale: locale.value,
      limit: limit.value,
      offset: offset.value,
      type: currentNewsTypeForGql.value,
    });

    isLoadingArticles.value = false;

    if (articlesError != null) {
      captureException(articlesError);
    } else {
      return articlesData.articles as Array<StrapiArticle>;
    }

    return [];
  };
  const { data: articles } = await useAsyncData(
    `gp-news-articles-${locale.value}-${currentNewsTypeForGql.value}-${limit.value}-${offset.value}`,
    fetchArticles,
  );

  const paginateNews = async () => {
    currentPage.value += 1;
    articles.value = articles.value.concat(await fetchArticles());
  };

  const handleSelectNewsType = async (val: SelectItem) => {
    // reset pagination and start anew
    if (currentNewsType.value.key !== val.key) {
      currentPage.value = 0;
      currentNewsType.value = val;
      articles.value = await fetchArticles();
    }
  };

  return {
    paginateNews,
    handleSelectNewsType,
    articles,
    currentNewsType,
    newsTypeOptions,
    isLoadingArticles,
  };
};
